import React, { useEffect } from 'react'
import { RiNotificationLine, RiFullscreenFill } from 'react-icons/ri';
import Cookies from 'js-cookie';
import { RiLogoutBoxLine } from 'react-icons/ri';
import { useLocation, useNavigate } from 'react-router-dom';

const Topbar = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const toggleFullScreen = () => {
        if (!document.fullscreenElement) {
            if (document.documentElement.requestFullscreen) {
                document.documentElement.requestFullscreen();
            }
        } else {
            if (document.exitFullscreen) {
                document.exitFullscreen();
            }
        }
    };

    const handleLogout = () => {
        Cookies.remove('token');
        window.location.href = '/';
    }

    const userCookie = Cookies.get('user');
    const user = userCookie ? JSON.parse(userCookie) : null;

    console.log('user - login', user);

    const isFirstTimeLogin =
        user?.first_login??
        user?.firstLogin ??
        user?.isFirstLogin ??
        user?.isFirstTimeLogin ??
        user?.mustChangePassword ??
        user?.forcePasswordChange;

    const mustForceChangePassword =
        isFirstTimeLogin === true || isFirstTimeLogin === 'true' || isFirstTimeLogin === 1;

    useEffect(() => {
        if (!mustForceChangePassword) return;
        if (location.pathname === '/hr/change-password') return;
        navigate('/hr/change-password', { replace: true });
    }, [location.pathname, mustForceChangePassword, navigate]);

    return (
        <div>
            <>{ /* app-header */}
                <div className="app-header-area">
                    <header className="app-header" id="header">
                        <div className="app-header-inner">
                            <div className="app-header-left">
                                <div className="d-flex align-center gap-15">
                                    <div className="app-header-element">
                                        <a className="sidebar-toggle-bar" id="sidebarToggle" href="javascript:void(0);">
                                            <div className="sidebar-menu-bar">
                                                <span />
                                                <span />
                                                <span />
                                            </div>
                                        </a>
                                    </div>
                                    <div className="app-header-ls-logo">
                                        { /* large screen logo */}
                                        <a className="app-header-ls-dark-logo" href="/">
                                            <img src="/assets/images/burray/burray.png" alt="image" />
                                        </a>
                                        <a className="app-header-ls-light-logo" href="/">
                                            <img src="/assets/images/burray/burray.png" alt="image" />
                                        </a>
                                    </div>
                                    <div className="app-header-mobile-logo">
                                        <a className="app-header-dark-logo" href="/">
                                            <img src="/assets/images/burray/burray.png" alt="image" />
                                        </a>
                                        <a className="app-header-light-logo" href="/">
                                            <img src="/assets/images/burray/burray.png" alt="image" />
                                        </a>
                                    </div>
                                </div>

                            </div>
                            <div className="app-header-right">
                                <div className="app-header-search-modal">
                                    <button type="button" className="app-header-circle" data-bs-toggle="modal" data-bs-target="#searchModal">
                                        <i className="ri-search-line" />
                                    </button>
                                </div>



                                <div className="app-header-fullscreen app-header-circle cursor-pointer">
                                    <div onClick={toggleFullScreen}>
                                        <RiFullscreenFill />
                                    </div>
                                </div>

                                <div className="app-header-notification">
                                    <div className="dropdown">
                                        <a className="dropdown-toggle" href="javascript:void(0);" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                            <span className="app-header-circle"><RiNotificationLine /></span>
                                        </a>
                                        <ul className="dropdown-menu">
                                            <li className="dropdown-menu-header">
                                                <h5>Notification</h5>
                                                <span className="badge bg-label-primary">8 New</span>
                                            </li>
                                            <li className="dropdown-notifications-list card-scrollbar">
                                                <ul>
                                                    <li className="dropdown-notifications-list-item">
                                                        <div className="avatar">
                                                            <img className="radius-100" src="/assets/images/avatar/avatar-thumb-dummy.png" alt="image not found" />
                                                        </div>
                                                        <div className="content">
                                                            <h6 className="mb-5">Not yet Functional</h6>
                                                            <p className="mb-5">Notifications are not yet functional</p>
                                                            <span className="text-body-secondary">Just now</span>
                                                        </div>
                                                    </li>
                                                </ul>
                                            </li>
                                            <li className="dropdown-notifications-btn">
                                                <a className="btn btn-primary w-100" href="#">View all
                                                    notifications</a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>

                                <div className="app-header-user">
                                    <div className="dropdown">
                                        <a className="dropdown-toggle" href="javascript:void(0);" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                            <div className="author">
                                                <div className="author-thumb">
                                                    <img src="/assets/images/avatar/avatar-thumb-dummy.png" alt="user" />
                                                </div>
                                                <h6 className="author-name lh-1">Profile</h6>
                                            </div>
                                        </a>
                                        <ul className="dropdown-menu">
                                            <li className="dropdown-menu-header">
                                                <div className="d-flex align-items-center gap-10">
                                                    <div className="avatar">
                                                        <img className="radius-100" src="/assets/images/avatar/avatar-thumb-dummy.png" alt="user" />
                                                    </div>
                                                    <div className="content">
                                                        <h6 className="mb-0">{user?.email || 'User Account'}</h6>
                                                        <small className="text-muted">HR Manager</small>
                                                    </div>
                                                </div>
                                            </li>
                                            <hr className="dropdown-divider" />
                                            <li className="bd-user-info-list"><a onClick={handleLogout} style={{ cursor: 'pointer' }}><RiLogoutBoxLine /> Logout</a></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </header>
                    <div className="body__overlay" />
                </div>
                { /* app-header */}</>
        </div>
    )
}

export default Topbar